import axios from "lib/axios";

const getMyTimelines = async ({ band }) => {
  // console.log("api instance band:", band);
  const { data } = await axios.get(`/timeline?band=${band}`);
  return data;
};

const getTimelines = async ({ frequency, band }) => {
  const { data } = await axios.get(
    `/timelines?band=${band}&frequency=${frequency}`
  );
  return data;
};

const searchTimelines = async ({ searchQuery, band }) => {
  const { data } = await axios.get(
    `/timelines?band=${band}&s=${searchQuery}`
  );
  return data;
};

export { getMyTimelines, getTimelines , searchTimelines };
